/**
 * Email Validation
 * 
 * Uses yup's built-in email validation plus a TLD check
 * to reject bare domains like "f@f".
 */

import * as yup from 'yup';

// TLD = Top-Level Domain (e.g. ".com", ".co.uk"). Requires a dot followed by 2+ letters at the end.
const TLD_PATTERN = /\.[a-zA-Z]{2,}$/;

const strictEmailSchema = yup.string().email().matches(TLD_PATTERN);

/**
 * Validate if an email address is valid
 * 
 * @param value - Email address to validate
 * @returns true if valid, false otherwise
 * 
 * @example
 * validateEmail('user@example.com') // true
 * validateEmail('invalid') // false
 * validateEmail('f@f') // false
 */
export function validateEmail(value: string | undefined): boolean {
  if (!value) return false;
  
  try {
    strictEmailSchema.validateSync(value);
    return true;
  } catch {
    return false;
  }
}

/**
 * Normalize email address (lowercase, trim whitespace)
 * 
 * @param value - Email address to normalize
 * @returns Normalized email address
 * 
 * @example
 * normalizeEmail('  User@Example.COM  ') // 'user@example.com'
 */
export function normalizeEmail(value: string): string {
  return value.trim().toLowerCase();
}
